<Panel header="Facturatiegegevens" style="min-width: 25em; height: 100%">
    <template #icons>
        <Button @click="goToBillingDetails" size="small" :disabled="errorLoading">
            Aanpassen
            <pencil-icon />
        </Button>
    </template>
    <div>
        <template v-if="loading">
            <aeg-loader />
        </template>
        <template v-else-if="errorLoading">
            <aeg-error-loading error-message="Er ging iets mis bij het ophalen van uw facturatiegegevens." @try-again="loadBillingDetails" />
        </template>
        <template v-else>
            <aeg-billing-details :billing-details="billingDetail" />
        </template>
    </div>
</Panel>
